module.exports = __webpack_public_path__ + "img/app-mb-icon.6aede08.webp";